import React, { useEffect, useState } from "react";
import "./MissionPopup.css";
import { FileText } from "lucide-react";

import { authFetch } from '../../HttpClient';

export default function NoteRDV({ client, onClose }) {
  const [notes, setNotes] = useState([]);
  const [loading, setLoading] = useState(true);

  function formatNoteResume(text) {
    if (!text) return "";

    // Échappe le HTML pour éviter toute injection
    const escapedText = text.replace(/</g, "&lt;").replace(/>/g, "&gt;");

    // Mise en gras pour les **textes**
    const boldedText = escapedText.replace(
      /\*\*(.*?)\*\*/g,
      "<strong>$1</strong>"
    );

    // Convertit les sauts de ligne
    const withLineBreaks = boldedText
      .split("\n")
      .map((line) => {
        // Gère les listes numérotées simples
        if (/^\d+\.\s/.test(line)) {
          return `<p style="margin-left:1em;">${line}</p>`;
        }
        return `<p>${line}</p>`;
      })
      .join("");

    return withLineBreaks;
  }

  useEffect(() => {
    const fetchNotes = async () => {
      try {
        const response = await authFetch(`https://backend-myalfa.vercel.app/api/clients/${client.id}`
        );
        const data = await response.json();
        setNotes(data.noteRDVs || []);
      } catch (error) {
        console.error("Erreur lors du chargement des notes RDV :", error);
      } finally {
        setLoading(false);
      }
    };

    fetchNotes();
  }, [client]);

  return (
    <div className="mission-overlay" onClick={onClose}>
      <div className="mission-popup" onClick={(e) => e.stopPropagation()}>
        <h3>
          {client.nom} (Client ID: {client.id})
        </h3>

        {loading ? (
          <div className="spinner"></div>
        ) : notes.length === 0 ? (
          <p className="no-modif">Aucune modification trouvée.</p>
        ) : (
          <div className="modif-list">
            {notes.map((note) => (
              <div key={note.id} className="modif-card">
                {/* <p>
                  <strong>Note de base :</strong> {note.noteDeBase}
                </p> */}
                <div>
                  <p className="text-sm text-gray-500">
                    Créé le {new Date(note.createdAt).toLocaleDateString()}
                  </p>
                  <br />
                  <strong>Résumé de la discussion:</strong>

                  <div
                    className="note-resume"
                    dangerouslySetInnerHTML={{
                      __html: formatNoteResume(note.noteResume),
                    }}
                  />

                  {note.documentUrl && (
                    <a
                      href={note.documentUrl}
                      target="_blank"
                      rel="noreferrer"
                      className="inline-flex items-center gap-1 mt-2 text-xs font-medium text-[#840040] hover:underline"
                    >
                      <FileText size={14} />
                      Consulter le document
                      {note.documentName ? ` — ${note.documentName}` : ""}
                    </a>
                  )}
                </div>
              </div>
            ))}
          </div>
        )}

        <button className="close-btn" onClick={onClose}>
          Fermer
        </button>
      </div>
    </div>
  );
}
